import { ListItemButton, styled } from '@mui/material';

const NavItemButton = styled(ListItemButton)(
    ({ theme }) => `
    justify-content: center;
    padding: 0;
    height: 34px;
    min-width: auto;
    &:hover {
        color: ${theme.palette.primary.light};
    }
`,
);

NavItemButton.displayName = 'NavItemButton';
export default NavItemButton;
